import React,{useState,useEffect} from "react"

import LoadingComp from "../common/LoadingComp";
import PopupDialog from "../common/controls/PopupDialog";

import { ReviewingStatus, ReviewingStatusLabel } from "../../common/attestationStatus";
import AttestationForm from "../attestations/AttestationForm";
import AttestationService from "../../services/AttestationService";

const AttestationDetailPopup = (props)=>{

    const [editing,setEditing] = useState(false);
    const [data,setData] = useState(props.data);
    
    const [loading, setLoading] = useState(false);
    const [reloadList, setReloadList] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const handleDetails = (id) => {
        setLoading(true);

        AttestationService.GetDetails(id)
            .then((result) => {
              setLoading(false);
              setData(result);
              setShowDetail(true);
              props.updateAttestationStatus(result);
            },
            (err) => {
              setLoading(false);
            }
        );
    };

    const handleSaveClick = (item) => {
        AttestationService.SaveForm(item);
    };

    const handleSubmitClick = (item) => {
        AttestationService.SubmitForm(item)
            .then((res) => {
                props.handleClose(true);
            })
            .catch((err) => {
                
            });
    };

    const handleExport = (id, fileName)=>{
        AttestationService.Export(id, fileName);
    };

    const handleReopen = (item)=>{
        AttestationService.ReopenForm(item)
            .then(() => {
                item.status = ReviewingStatus;
                item.statusLabel = ReviewingStatusLabel;
                props.updateAttestationStatus(item);
            });
    };

    useEffect(()=>{
        handleDetails(props.data.id);
    },[]);

    return (
        <PopupDialog handleClose={props.handleClose}>
            {showDetail && (
                <AttestationForm handleClose={p=>props.handleClose(reloadList)} editorItem={data} handleSaveClick={handleSaveClick} handleSubmitClick={handleSubmitClick} handleReopen={handleReopen} handleExport = {handleExport}/>
            )}

            {loading && <LoadingComp />}
        </PopupDialog>
    )
};

export default AttestationDetailPopup;